import { render, staticRenderFns } from "./DetailPo.vue?vue&type=template&id=705c2ba6&"
import script from "./DetailPo.vue?vue&type=script&lang=js&"
export * from "./DetailPo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports